import Vue from 'vue';

export default Vue.component('confirm-modal', {
  template: require('./template.html'),
  name: 'confirm-modal',
  props: ['droplet'],
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/confirm-modal/index.js